<template>
    <div>
        <div class="flex flex-col">
            <div class="flex items-center gap-6">
                <div 
                    v-for="type in buildingTypes" :key="type.id"
                    class="h-64 flex flex-1 flex-col relative bg-gray-50 hover:bg-gray-100 border border-b-0 shadow-md cursor-pointer"
                    @click="building.type_id = type.id">
                        <div v-if="type.id == building.type_id" class="absolute top-0 right-0 rounded-full -mt-3 -mr-3">
                            <inline-svg name="check-large"></inline-svg>
                        </div>
                        <div class="flex-1 flex items-center justify-center">
                            <inline-svg :name="type.svg_name"></inline-svg>
                        </div>
                        <span
                            class="p-4 text-center text-white uppercase"
                            :class="type.id == building.type_id ? 'bg-green-600' : 'bg-gray-700'">
                                {{ type.type }}
                        </span>
                </div>
            </div>
        </div>
        <input type="hidden" name="type_id" :value="building.type_id">
	</div>
</template>

<script>
    export default {
    	props: {
    		buildingData: {
    			type: Object,
    			required: true
    		}
    	},

    	data() {
    		return {
    			building: this.buildingData,

                buildingTypes: {}
    		}
    	},

        mounted() {
            this.initBuildingTypes();
        },

        computed: {
            regions() {
                return _.filter(this.availableRegions, ['country_id', this.building.country_id]);
            }
        },

        methods: {
            initBuildingTypes() {
                axios.get('/api/building-types').then((response) => {
                    this.buildingTypes = response.data.types;
                }).catch((error) => {
                    console.log(error);
                });
            },
        }
    }
</script>